import React, { useEffect, useState } from 'react';
import { Clock, Flame } from 'lucide-react';
export function UrgencyBar() {
  // Start at 14:50 (14 mins, 50 secs)
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 w-full bg-red-600 text-white z-50 shadow-sm" data-id="element-371">
      <div className="max-w-7xl mx-auto px-4 py-1 flex flex-col md:flex-row items-center justify-center gap-1 md:gap-4 text-xs md:text-sm font-bold text-center bg-[#23A733]" data-id="element-372">
        <div className="flex items-center gap-1.5" data-id="element-373">
          <Clock className="w-4 h-4 animate-pulse" data-id="element-374" />
          <span data-id="element-375">
            OFERTA EXPIRA EN:{' '}
            <span className="font-mono text-sm bg-red-800 px-1.5 py-0.5 rounded" data-id="element-376">
              {minutes.toString().padStart(2, '0')}:
              {seconds.toString().padStart(2, '0')}
            </span>
          </span>
        </div>
        <div className="hidden md:block w-px h-4 bg-red-400" data-id="element-377"></div>
        <div className="flex items-center gap-1.5 text-yellow-300" data-id="element-378">
          <Flame className="w-4 h-4" data-id="element-379" />
          <span data-id="element-380">SOLO QUEDAN 3 CUPOS</span>
        </div>
      </div>
    </div>;
}